import * as React from "react";
import { styled } from "@mui/system";
import Box from "@vapor/react-material/Box";
import TableContainer from "@vapor/react-material/TableContainer";
import Table from "@vapor/react-material/Table";
import TableHead from "@vapor/react-material/TableHead";
import TableRow from "@vapor/react-material/TableRow";
import TableCell from "@vapor/react-material/TableCell";
import TableBody from "@vapor/react-material/TableBody";
import IconButton from "@vapor/react-material/IconButton";
import Button from "@vapor/react-material/Button";
import { TableCellProps } from "@vapor/react-material/TableCell";
import Typography from "@vapor/react-extended/ExtendedTypography";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTrashAlt } from "@fortawesome/free-regular-svg-icons/faTrashAlt";
import { faPlus } from "@fortawesome/free-solid-svg-icons/faPlus";

type headers = {
  label: string;
  cellProps?: Object;
};

type column = {
  renderCellProps?: Object;
  renderColumn: Function;
  renderHeader: Function;
  tableCellProps?: TableCellProps;
};

type row = any;

export type VaporEditableTableProps = {
  headers: headers[];
  columns: column[];
  rows: row[];
  deleteRow: Function;
  onAddRow: any;
  buttonTitle?: string;
  buttonIcon?: React.ReactElement;
};

export const VaporEditableTable = styled(
  (props: VaporEditableTableProps) => {
    return (
      <Box>
        <TableContainer>
          <Table>
            <TableHead>
              <TableRow>
                {props.headers.map((header, headerIndex) => (
                  <TableCell
                    key={headerIndex}
                    padding="none"
                    borderBottom={false}
                    {...header.cellProps}
                  >
                    <Typography variant="bodySmall700">
                      {header.label}
                    </Typography>
                  </TableCell>
                ))}
              </TableRow>
            </TableHead>
            <TableBody>
              {props.rows.map((row, rowIndex) => (
                <TableRow hover={false} key={rowIndex}>
                  {props.columns.map((column, columnIndex) => (
                    <TableCell
                      key={columnIndex}
                      padding="none"
                      borderBottom={false}
                      {...column.tableCellProps}
                    >
                      {column.renderColumn({
                        rowData: row,
                        rowIndex,
                        rows: props.rows
                      })}
                    </TableCell>
                  ))}
                  <TableCell padding="none" borderBottom={false}>
                    <IconButton
                      color="error"
                      onClick={() => props.deleteRow(rowIndex)}
                      disabled={props.rows.length === 1}
                    >
                      <FontAwesomeIcon
                        icon={faTrashAlt}
                        style={{ fontSize: "16px" }}
                      />
                    </IconButton>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
        {props.buttonTitle === undefined || props.buttonTitle === "" ? (
          <IconButton color="primary" onClick={props.onAddRow}>
            {props.buttonIcon === undefined ? (
              <FontAwesomeIcon icon={faPlus} />
            ) : (
              props.buttonIcon
            )}
          </IconButton>
        ) : (
          <Button
            startIcon={
              props.buttonIcon === undefined ? (
                <FontAwesomeIcon icon={faPlus} />
              ) : (
                props.buttonIcon
              )
            }
            onClick={props.onAddRow}
          >
            {props.buttonTitle}
          </Button>
        )}
      </Box>
    );
  },
  {
    name: "VaporEditableTable",
    slot: "Root",
    overridesResolver: (props, styles) => []
  }
)(({ theme }) => ({}));
